






































import { Component, Vue, Prop } from "vue-property-decorator";
import * as apiEvents from "@/api/events";

@Component({})
export default class Events extends Vue {
  search = "";
  loading = true;
  headers = [
    {
      text: "Race Name",
      align: "left",
      value: "name"
    },
    { text: "Race Date", value: "eventdate" },
    { text: "", value: "" }
  ];
  events: any = [];

  handleClick(eventId: string) {
    this.$router.push("/events/edit/" + eventId);
  }

  getTableFromCache(eventCache: any) {
    const localEvents = [];

    for (const key in eventCache) {
      if (eventCache.hasOwnProperty(key)) {
        const eventobj = eventCache[key];
        const newEvent = {
          eventId: key,
          name: eventobj.name,
          distance: eventobj.distance,
          hasresults: eventobj.hasresults,
          eventdate: eventobj.eventdate.toDateString()
        };

        localEvents.push(newEvent);
      }
    }
    return localEvents;
  }

  getEvents() {
    this.loading = true;
    apiEvents
      .getEvents()
      .then(eventCache => {
        this.events = this.getTableFromCache(eventCache);
      })
      .catch(err => {
        console.log("error " + err);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  created() {
    this.getEvents();
  }
}
